const isDevelopment = process.env.REACT_APP_ENV === 'development';

const config = {
  API_BASE: isDevelopment
    ? process.env.REACT_APP_LOCAL_API_BASE
    : process.env.REACT_APP_API_BASE,

  LOGIN_ENDPOINT: isDevelopment
    ? process.env.REACT_APP_LOCAL_BACKEND_LOGIN_ENDPOINT
    : process.env.REACT_APP_BACKEND_LOGIN_ENDPOINT,

  WEBHOOK_ENDPOINT: process.env.REACT_APP_WEBHOOK_ENDPOINT,
};

export default config;
